import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import NavigationTabs from '../../components/Tabs/NavigationTabs';
import TabsPageLayout from '../../components/PageLayout/TabsPageLayout';
import Configs from './SupplierConfigs';

const ViewSupplier = ({ }) => {
    return (
        <Wrapper>
            <TabsPageLayout>
                <NavigationTabs tabs={Configs.tabs}>
                </NavigationTabs>
            </TabsPageLayout>
        </Wrapper>
    );
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser())
});

const ViewSupplierWithRouter = withRouter(ViewSupplier);
export default connect(mapStateToProps, mapDispatchToProps)(ViewSupplierWithRouter);
